import { IDropdownStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';

/* 
    Fluent UI Dropdown component hover state is not working properly in dark theme, 
    therefore overriding styles using semantic colors for it as below. Although the selected
    colors are not very ideal use case for dropdown, since currently css vars of cardboard-app-data-theme 
    cannot be accessed from root layer dropdown menu callout, I used most semantically closed colors to override.
*/
export const getDropdownStyles = (
    themeSetting: Theme,
    theme: ITheme
): Partial<IDropdownStyles> => {
    return {
        ...(themeSetting === Theme.Dark && {
            dropdownItem: {
                selectors: {
                    ':hover': {
                        backgroundColor: `${theme.semanticColors.listItemBackgroundHovered} !important`
                    }
                }
            },
            dropdownItemSelected: {
                backgroundColor: `${theme.semanticColors.listItemBackgroundChecked} !important`
            }
        }),
        title: {
            borderColor: 'var(--cb-app-color-input-border) !important'
        }
    };
};
